import { DESKTOP_MIN_WIDTH } from 'constants';

const TAG = 'service_worker';

const sw = {
  isSupport() {
    const serviceWorker =
      'serviceWorker' in navigator && window.innerWidth >= DESKTOP_MIN_WIDTH;
    if (!serviceWorker) {
      console.error(
        `🔥 ${TAG} ❌ isSupport ➡️ ERROR ➡️ Service Worker doesn't supported! ↩`
      );
      return false;
    }
    console.log(`⭐ ${TAG} 👉 Service Worker is supported! ↩`, serviceWorker);
    return true;
  },
  isLocalhost: () =>
    Boolean(
      window.location.hostname === 'localhost' ||
        // [::1] is the IPv6 localhost address.
        window.location.hostname === '[::1]' ||
        // 127.0.0.0/8 are considered localhost for IPv4.
        window.location.hostname.match(
          /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
        )
    ),
  register(config, swUrl) {
    if (sw.isSupport()) {
      // The URL constructor is available in all browsers that support SW.
      const publicUrl = new URL(window.location.origin, window.location.href);

      if (publicUrl.origin !== window.location.origin) {
        // Our service worker won't work if REACT_APP_PUBLIC_URL is on a different origin
        // from what our page is served on. This might happen if a CDN is used to
        // serve assets; see https://github.com/facebook/create-react-app/issues/2374
        console.error(
          `🔥 ${TAG} ❌ register ➡️ ERROR ➡️ Our service worker won't work if REACT_APP_PUBLIC_URL is on a different origin from what our page is served on ↩`
        );
        return;
      }

      window.addEventListener('load', () => {
        const configParams = new URLSearchParams(config).toString();

        swUrl = `${swUrl}?${configParams}`;

        if (sw.isLocalhost()) {
          // This is running on localhost. Let's check if a service worker still exists or not.
          sw.checkValidServiceWorker(swUrl, config);
          console.log(`⭐ ${TAG} 👉 register ➡️ Running on localhost ↩`);

          // Add some additional logging to localhost, pointing developers to the
          // service worker/PWA documentation.
          navigator.serviceWorker.ready
            .then(() => {
              console.log(
                `⭐ ${TAG} 👉 register ➡️ load ➡️ This web app is being served cache-first by a service worker. To learn more, visit https://bit.ly/CRA-PWA ↩`
              );
            })
            .catch((error) => {
              console.error(
                `🔥 ${TAG} ❌ register ➡️ load ➡️ ERROR ↩`,
                error?.message
              );
            });
        } else {
          // Is not localhost. Just register service worker
          sw.registerValidSW(swUrl, config);
          console.log(`⭐ ${TAG} 👉 register ➡️ Running on build ↩`);
        }
      });
    }
  },
  registerValidSW(swUrl, config) {
    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        registration.onupdatefound = () => {
          const installingWorker = registration.installing;
          if (installingWorker == null) {
            return;
          }
          installingWorker.onstatechange = () => {
            if (installingWorker.state === 'installed') {
              if (navigator.serviceWorker.controller) {
                // At this point, the updated precached content has been fetched,
                // but the previous service worker will still serve the older
                // content until all client tabs are closed.
                console.log(
                  `⭐ ${TAG} 👉 registerValidSW ➡️ New content is available and will be used when all tabs for this page are closed. See https://bit.ly/CRA-PWA. ↩`
                );
                // Execute callback
                if (config && config.onUpdate) {
                  config.onUpdate(registration);
                }
              } else {
                // At this point, everything has been precached.
                // It's the perfect time to display a
                // "Content is cached for offline use." message.
                console.log(
                  `⭐ ${TAG} 👉 registerValidSW ➡️ Content is cached for offline use. ↩`
                );

                // Execute callback
                if (config && config.onSuccess) {
                  config.onSuccess(registration);
                }
              }
            }
          };
        };
      })
      .catch((error) => {
        console.error(
          `🔥 ${TAG} ❌ registerValidSW ➡️ ERROR ↩`,
          error?.message
        );
      });
  },
  checkValidServiceWorker(swUrl, config) {
    // Check if the service worker can be found. If it can't reload the page.
    fetch(swUrl, {
      headers: { 'Service-Worker': 'script' },
    })
      .then((response) => {
        // Ensure service worker exists, and that we really are getting a JS file.
        const contentType = response.headers.get('content-type');
        if (
          response.status === 404 ||
          (contentType != null && contentType.indexOf('javascript') === -1)
        ) {
          // No service worker found. Probably a different app. Reload the page.
          navigator.serviceWorker.ready.then((registration) => {
            registration.unregister().then(() => {
              console.log(
                `⭐ ${TAG} 👉 checkValidServiceWorker ➡️ No service worker found. Probably a different app. Reload the page ↩`
              );
              window.location.reload();
            });
          });
        } else {
          // Service worker found. Proceed as normal.
          sw.registerValidSW(swUrl, config);
          console.log(
            `⭐ ${TAG} 👉 checkValidServiceWorker ➡️ Service worker found. Proceed as normal. ↩`
          );
        }
      })
      .catch(() => {
        console.error(
          `🔥 ${TAG} ❌ checkValidServiceWorker ➡️ ERROR ➡️ No internet connection found. App is running in offline mode. ↩`
        );
      });
  },
  unregister(scriptURL) {
    navigator.serviceWorker
      .getRegistrations()
      .then(function (registrations) {
        console.log(
          `⭐ ${TAG} 👉 unregister ➡️ These service workers have been installed. ↩`,
          registrations
        );
        for (let registration of registrations) {
          // Check the scriptURL to target a specific service worker
          if (registration.active.scriptURL === scriptURL) {
            registration.unregister();
            console.log(
              `⭐ ${TAG} 👉 unregister ➡️ Service worker unregistered ↩`,
              registration.active.scriptURL
            );
          }
        }
      })
      .catch((error) => {
        console.error(`🔥 ${TAG} ❌ unregister ➡️ ERROR ↩`, error?.message);
      });
  },
};

export default sw;
